import styled from 'styled-components';
import { Column } from '@libs/uikit/Components';

export const StyledColumn = styled(Column)`
    &:first-child {
        padding-left: 12px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    &:last-child {
        padding-right: 12px;
        padding-top: 12px;
        padding-bottom: 12px;
    }
`;
